import { apiPost } from './Api_Functions'
import bcrypt from 'bcryptjs-react'
import { regenerateSession } from './utilities/session_value_utils'
/**
 *
 * @param {*} loginCheck Only for login checks, if play cell (false)
 */
export const CheckCredentials = async (username, password, dbUserPassword, loginCheck = true) => {
  if (dbUserPassword) {
    const dbSalt = dbUserPassword.salt
    const challenge = dbUserPassword.challenge

    const hash1 = bcrypt.hashSync(password, dbSalt)
    const hash2 = bcrypt.hashSync(username + hash1, dbSalt)

    const hashedPassword3 = bcrypt.hashSync(username + hash2, challenge)

    dbUserPassword.hashedPassword = hashedPassword3
    dbUserPassword.salt = null
    if (!loginCheck) {
      return await apiPost('frontEndLogin', dbUserPassword, { 'X-MIC-CONNECTIONS': 'false' })
    }
    regenerateSession()
    return await apiPost('frontEndLogin', dbUserPassword)
  }
}
